<template>
  <section class="content">
    <div
      class="modal fade"
      id="add-new-config"
      tabindex="-1"
      role="dialog"
      aria-labelledby="add-new-config"
      style="display: none;"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" id="closeNewConfig" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">
                ×
              </span>
            </button>
            <h4 class="modal-title" id="forgot_ModalLabel">
              <i class="fa fa-plus mr-5"></i>{{ 'new_avendu_configuration' | translate }}
            </h4>
          </div>
          <div class="modal-body">
            <div class="input-group pb-10">
              <div class="radio">
                <label class="margin-r-5">
                  <input
                    type="radio"
                    name="active_radio"
                    :value="1"
                    :checked="newAvenduConfiguration.is_active"
                    v-model="newAvenduConfiguration.is_active"
                  >
                  <strong>{{ 'activated' | translate }}</strong>
                </label>
                <label>
                  <input
                    type="radio"
                    name="active_radio"
                    :value="0"
                    :checked="!newAvenduConfiguration.is_active"
                    v-model="newAvenduConfiguration.is_active"
                  >
                  <strong>{{ 'deactivated' | translate }}</strong>
                </label>
              </div>
            </div>
            <div class="input-group pb-10">
              <span class="input-group-addon">{{ 'gln' | translate }}</span>
              <select
                data-vv-as="store"
                :class="{'form-control': true}"
                name="marketplace"
                v-model="newAvenduConfiguration.store_id"
              >
                <option value="">{{ 'please_select' | translate }}...</option>
                <template v-for="(store, index) in stores">
                  <option :key="index" class="normal" :value="store.id">{{ store.gln }} - {{ store.store_number }} - {{ store.name }}</option>
                </template>
              </select>
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn btn-app btn-success" @click="postAvenduConfig">
              <i class="fa fa-save"></i>{{ 'create' | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12">
        <div class="nav-tabs-custom no-margin">
          <ul class="nav nav-tabs">
            <li class="active">
              <a href="#settings" data-toggle="tab" aria-expanded="false">{{ 'settings' | translate }}</a>
            </li>
          </ul>
        </div>
        <div class="tab-content">
          <div class="tab-pane active" id="settings">
            <div class="row">
              <div class="col-xs-12">
                <div class="box box-primary">
                  <div class="box-body">
                    <h5 class="mb-10">
                      <i class="fa fa-cogs text-muted mr-5"></i>{{ 'avendu_configuration' | translate }}:
                    </h5>
                    <div class="margin"></div>
                    <div class="row">
                      <div class="box-body">
                        <div class="nav-tabs-custom">
                          <ul class="nav nav-tabs">
                            <template v-for="(marketplace, index) in marketplaces">
                              <li :key="index" :class="[index === 0 ? 'active' : '']">
                                <a
                                  :href="`#tab_${index}`"
                                  class="text-center"
                                  data-toggle="tab"
                                  aria-expanded="false"
                                  @click="getAvenduData(marketplace.id)"
                                >
                                  {{ marketplace.name | translate }}
                                </a>
                              </li>
                            </template>
                          </ul>
                          <div class="tab-content">
                            <button
                              aria-controls="add-note"
                              aria-expanded="false"
                              class="btn btn-info mt-10 mb-10"
                              data-target="#add-new-config"
                              data-toggle="modal"
                              type="button"
                            >
                              <i class="fa fa-plus-square mr-5"></i>{{ 'create_new_avendu_configuration' | translate }}
                            </button>
                            <template v-for="(config, index) in configs">
                              <hr :key="`hr_${index}`">
                              <div :key="`row_${index}`" class="mt-10" style="display: flex">
                                <div class="input-group pb-10 row-margin-right">
                                  <div class="radio">
                                    <label class="margin-r-5">
                                      <input
                                        type="radio"
                                        :name="`active_radio_${index}`"
                                        :value="1"
                                        :checked="config.is_active"
                                        v-model="config.is_active"
                                      >
                                        <strong>{{ 'activated' | translate }}</strong>
                                    </label>
                                    <label>
                                      <input
                                        type="radio"
                                        :name="`active_radio_${index}`"
                                        :value="0"
                                        :checked="!config.is_active"
                                        v-model="config.is_active"
                                      >
                                        <strong>{{ 'deactivated' | translate }}</strong>
                                    </label>
                                  </div>
                                </div>
                                <div class="input-group pb-10 store-dropdown row-margin-right">
                                  <span class="input-group-addon">{{ 'gln' | translate }}</span>
                                  <input
                                    class="form-control"
                                    :value="setInputGLNValue(config.store_id)"
                                    disabled
                                  />
                                </div>
                                <div class="input-group row-margin-right">
                                  <button @click="putAvenduConfig(config)" class="btn btn-flat btn-primary pull-right">
                                    <i class="fa fa-save mr-5"></i> {{ 'save' | translate }}
                                  </button>
                                </div>
                              </div>
                            </template>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Avendu',
  data () {
    return {
      needUpdate: false,
      configs: [],
      marketplaces: [],
      stores: [],
      config: {},
      currMarketplaceId: '',
      newAvenduConfiguration: {
        is_active: 1,
        store_id: '',
        marketplace_id: ''
      }
    }
  },
  mounted () {
    this.getAvenduMarketplaces()
    this.getAvenduStores()
    this.getAvenduData(1)
  },
  methods: {
    getAvenduMarketplaces () {
      API.get('directsales/avendu/marketplaces')
        .then(res => {
          this.marketplaces = res.data
        })
    },
    getAvenduStores () {
      API.get('directsales/avendu/stores')
        .then(res => {
          this.stores = res.data
        })
    },
    getAvenduData (id) {
      this.currMarketplaceId = id
      API.get('directsales/avendu/configuration?marketplace_id=' + this.currMarketplaceId)
        .then(res => {
          this.configs = res.data
        })
    },
    putAvenduConfig (config) {
      API.put('directsales/avendu/configuration', {
        configuration_id: config.id,
        is_active: config.is_active,
        store_id: config.store_id,
        marketplace_id: config.marketplace_id
      }).catch(error => {
        this.$store.commit('pushAlert', {type: 'danger', dismiss: 5, message: error, icon: 'icon fa fa-ban', show: true})
      }).finally(() => location.reload())
    },
    postAvenduConfig () {
      API.post('directsales/avendu/configuration', {
        is_active: this.newAvenduConfiguration.is_active,
        store_id: this.newAvenduConfiguration.store_id,
        marketplace_id: this.currMarketplaceId
      }).catch(error => {
        this.$store.commit('pushAlert', {type: 'danger', dismiss: 5, message: error, icon: 'icon fa fa-ban', show: true})
      }).finally(() => location.reload())
    },
    setInputGLNValue (id) {
      let store = this.stores.find(store => store.id === id)
      return store.gln + ' - ' + store.store_number + ' - ' + store.name
    }
  }
}
</script>

<style scoped>
  .store-dropdown {
    width: 50%;
  }
  .row-margin-right {
    margin-right: 3rem
  }
</style>



// WEBPACK FOOTER //
// src/components/views/Directsale/AvenduView.vue